import React, { Component } from 'react'
import { post, get } from '../../utils/networking'
import Footer from '../footer'
import Header from '../header'
import './style.css'
import $ from 'jquery'
import { Calendar } from 'react-date-range';
import { min } from 'moment';
import validation, { notEmpty, emailAddres, isValid } from '../../validations'
import TextIput from '../../textInput'
import { configs } from '../../helpers/constants';
import moment from 'moment'
import { resolve } from 'url';
import { concatStatic } from 'rxjs/operator/concat';
var validationData = {
    customerName: [notEmpty],
    mailAddress: [notEmpty, emailAddres],
    phone: [notEmpty],
    address: [notEmpty]
}
export default class Appointment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isStaffChoise: false,
            isNote: true,
            hours: 0,
            minutes: 0,
            isAM: true,
            date: "",
            appointmentNote: "",
            customerName: "",
            mailAddress: "",
            phone: "",
            address: "",
            serviceName: "",
            staff: {},
            qty: 1,
            keyReload: true,
            isProsessing: false,
            isSuccessBook: false,
            arrayService: [{}],
            currentService: 0,
            storeServices: [],
            services_key: -1,
            product_key: -1,
            isAddMoreService: false,
            currentWorkTimeTab: -1
        }
    }

    componentDidMount() {
        this.setState({
            date: moment(new Date)
        })
    }

    hanleReset() {
        let date = new Date;
        let {
            hours,
            minutes,
            isAM,
        } = this.state;
        hours = (date.getHours() > 12) ? (date.getHours() - 12) : date.getHours();
        minutes = date.getMinutes();
        isAM = (date.getHours() > 12) ? false : true;
        this.setState({
            hours: hours,
            minutes: minutes,
            isAM: isAM
        })
    }

    onNoteChange(e) {
        this.setState({
            appointmentNote: e.target.value
        })
    }

    componentWillMount() {

        get('user/getMyProfile', "customer", result => {
            this.setState({
                customerName: result.user.name,
                mailAddress: result.user.email,
                phone: result.user.phone,
                address: result.user.address,
            })
        })
        this.setState({
            arrayService: [{
                staffId: (this.props.staffs.length > 0) ? this.props.staffs[0].id : 0,
                staffName: (this.props.staffs.length > 0) ? this.props.staffs[0].name : "",
                service: this.props.service,
                quantity: 1
            }],
            storeServices: this.props.storeServices
        })

    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.service !== this.props.service) {
            this.setState({
                arrayService: [{
                    staffId: (this.props.staffs.length > 0) ? this.props.staffs[0].id : 0,
                    staffName: (this.props.staffs.length > 0) ? this.props.staffs[0].name : "",
                    service: nextProps.service,
                    quantity: 1
                }],
                storeServices: nextProps.storeServices
            })
        }
    }

    onSelectDate(value) {
        if (moment(value).diff(this.state.date) != 0) {
            this.handleResetStaff()
        }
        this.setState({
            date: (value) ? value : moment(this.state.date).format()
        });
    }

    onInputTime(e, target) {
        let {
            hours,
            minutes
        } = this.state;
        if (target === "h") {
            hours = (parseInt(e.target.value) < 0 || isNaN(parseInt(e.target.value))) ? 0 : (parseInt(e.target.value) > 12) ? 12 : parseInt(e.target.value)
        }
        if (target === "m") {
            minutes = (parseInt(e.target.value) < 0 || isNaN(parseInt(e.target.value))) ? 0 : (parseInt(e.target.value) > 59) ? 59 : parseInt(e.target.value)
        }
        this.setState({
            hours: hours,
            minutes: minutes
        }, () => {
            this.handleResetStaff()
        })
    }

    onTimeChange(target, action) {
        let {
            hours,
            minutes,
            isAM
        } = this.state;
        if (target === "h") {
            if (action === "up") {
                (hours < 12) ? (hours++) : 12;
            }
            else {
                (hours > 1) ? (hours--) : 1;
            }
            this.handleResetStaff()
        }
        if (target === "m") {
            if (action === "up") {
                if (minutes < 50) {
                    minutes += 10
                } else {
                    minutes = 0;
                    hours = hours < 12 ? ++hours : 1;
                    this.handleResetStaff()
                }
            }
            else {
                (minutes > 0) ? (minutes -= 10) : 0;
                this.handleResetStaff()
            }
        }
        if (target === "p") {
            if (action === "up") {
                isAM = true;
            }
            else {
                isAM = false;
            }
            this.handleResetStaff()
        }
        this.setState({
            hours: hours,
            minutes: (minutes > 59) ? 59 : (minutes < 0) ? 0 : minutes,
            isAM: isAM
        })
    }

    onQtyChange(index, status) {
        let { arrayService } = this.state;
        if (status === "up") {
            arrayService[index].quantity++;
            this.setState({
                arrayService
            })
        } else {
            arrayService[index].quantity = (arrayService[index].quantity > 1) ? arrayService[index].quantity - 1 : 1;
            this.setState({
                arrayService
            })
        }
    }

    handleBook() {
        let newDate = moment(moment(this.state.date).format("dddd, DD MM YYYY") + " " + ((this.state.isAM) ? this.state.hours : (this.state.hours + 12)) + ":" + this.state.minutes, "DD/MM/YYYY HH:mm").get();
        this.setState({
            isProsessing: true
        })
        let items = [];
        this.state.arrayService.map((item, i) => {
            let temp = {
                "staffId": item.staffId,
                "serviceId": item.service.id,
                "quantity": item.quantity
            }
            items.push(temp);
        })
        let param = {
            "storeId": parseFloat(this.props.storeId.trim()),
            "customerName": this.state.customerName,
            "customerPhone": this.state.phone,
            "note": this.state.appointmentNote,
            "date": moment.utc(newDate.toDate()).format("YYYY-MM-DD HH:mm:ss"),
            "items": items
        }
        post('appointment/book', param, "customer", result => {
            this.setState({
                qty: 1,
                isStaffChoise: false,
                keyReload: !this.state.keyReload,
                isProsessing: false,
                isSuccessBook: true
            })
            setTimeout(() => {
                this.setState({
                    isSuccessBook: false
                })
            }, 10000);
            $("#customer_info").fadeOut(500);
            $("#appointment_service").fadeIn(500);
            this.props.onFinishHandleBook;
        }, errors => {
            alert("Please select apointment day-time again");
            this.setState({
                isProsessing: false
            })
        })

    }

    getHoursToDay(workHours, appointments) {
        var today = this.state.date;
        var hours = "";
        // alert(today)
        workHours = workHours[0];
        switch (moment(today).day()) {
            case 0:
                hours = (workHours && workHours.sundayStart && workHours.sundayEnd) ? (workHours.sundayStart + " - " + workHours.sundayEnd) : "Off";
                break;
            case 1:
                hours = (workHours && workHours.mondayStart && workHours.mondayEnd) ? (workHours.mondayStart + " - " + workHours.mondayEnd) : "Off";
                break;
            case 2:
                hours = (workHours && workHours.tuesdayStart && workHours.tuesdayEnd) ? (workHours.tuesdayStart + " - " + workHours.tuesdayEnd) : "Off";
                break;
            case 3:
                hours = (workHours && workHours.wednesdayStart && workHours.wednesdayEnd) ? (workHours.wednesdayStart + " - " + workHours.wednesdayEnd) : "Off";
                break;
            case 4:
                hours = (workHours && workHours.thursdayStart && workHours.thursdayEnd) ? (workHours.thursdayStart + " - " + workHours.thursdayEnd) : "Off";
                break;
            case 5:
                hours = (workHours && workHours.fridayStart && workHours.fridayEnd) ? (workHours.fridayStart + " - " + workHours.fridayEnd) : "Off";
                break;
            case 6:
                hours = (workHours && workHours.saturdayStart && workHours.saturdayEnd) ? (workHours.saturdayStart + " - " + workHours.saturdayEnd) : "Off";
                break;
        }
        if (hours != "Off") {
            let newDate = moment(moment(this.state.date).format("dddd, DD MM YYYY") + " " + ((this.state.isAM) ? this.state.hours : (this.state.hours + 12)) + ":" + this.state.minutes, "DD/MM/YYYY HH:mm").get();
            if (appointments.length === 0) {
                hours = "Available"
                return hours
            }
            else {
                for (var i = 0; i < appointments.length; i++) {
                    if (moment.utc(newDate) <= (moment.utc(appointments[0].startTime)) || moment.utc(newDate) >= (moment.utc(appointments[0].endTime)))
                        hours = "Available"
                    else {
                        hours = "Inservice"
                        return hours
                    }
                }
            }
        }
        // alert(hours)
        return hours
    }

    checkStaffSchedule(date, workHours) {
        var day = moment(date).format('dddd')
        var isWork = false

        if (workHours && workHours.length > 0) {
            switch (day) {
                case "Sunday":
                    isWork = (workHours[0].sundayStart.length > 5 && workHours[0].sundayEnd.length > 5);
                    break;
                case "Monday":
                    isWork = (workHours[0].mondayStart.length > 5 && workHours[0].mondayStart.length > 5);
                    break;
                case "Tuesday":
                    isWork = (workHours[0].tuesdayStart.length > 5 && workHours[0].tuesdayEnd.length > 5);
                    break;
                case "Wednesday":
                    isWork = (workHours[0].wednesdayStart.length > 5 && workHours[0].wednesdayEnd.length > 5);
                    break;
                case "Thursday":
                    isWork = (workHours[0].thursdayStart.length > 5 && workHours[0].thursdayEnd.length > 5);
                    break;
                case "Friday":
                    isWork = (workHours[0].fridayStart.length > 5 && workHours[0].fridayEnd.length > 5);
                    break;
                case "Saturday":
                    isWork = (workHours[0].saturdayStart.length > 5 && workHours[0].saturdayEnd.length > 5);
                    break;
            }
        }
        return (isWork) ? "" : "disable";
    }

    showServiceList(i) {
        this.setState({
            services_key: (this.state.services_key === i) ? -1 : i,
            product_key: -1
        })
    }
    showProductList(j) {
        this.setState({
            product_key: j
        })
    }

    onSelectStaff(staff) {
        let { arrayService } = this.state;
        arrayService[this.state.currentService].staffId = staff.id
        arrayService[this.state.currentService].staffName = staff.name
        this.setState({
            arrayService,
            isStaffChoise: false
        })
    }
    handleResetStaff() {
        let { arrayService } = this.state;
        arrayService.map((item, i) => {
            item.staffId = 45
            item.staffName = "Any"
        })
        this.setState({
            arrayService
        })
    }

    render() {
        let {
            isStaffChoise,
            isNote,
            hours,
            minutes,
            isAM,
            appointmentNote,
            staffID,
            qty,
            isProsessing,
            isSuccessBook,
            arrayService,
            storeServices,
            services_key,
            product_key,
            isAddMoreService,
            currentService,
            currentWorkTimeTab
        } = this.state;

        let {
            isShow,
            service,
            storeName,
            staffs,
            selectStaff,
            storeId
        } = this.props;

        return (
            <div className="appointment_popup" style={{ display: (isShow) ? "block" : "none" }}>
                <div className="appointment_contain">
                    <div className="header">
                        <span className="title">Appointment</span>
                        <i className="fa fa-times" aria-hidden="true" onClick={this.props.handleClose}></i>
                    </div>
                    <div className="detail">
                        {(isSuccessBook) ? <p className="book-notify">Set up a successful appointment. Check your appointment list for detail.</p> : ""}
                        {
                            (!isStaffChoise) ?
                                <div className="service">
                                    <div id="appointment_service" className="appointment_service">
                                        <label>Please select datetime</label>
                                        <div className="date-time">
                                            <div className="date">
                                                <Calendar key={this.state.keyReload}
                                                    onInit={this.onSelectDate.bind(this)}
                                                    onChange={this.onSelectDate.bind(this)}
                                                    date={this.state.date}
                                                />
                                            </div>
                                            <div className="time">
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td onClick={this.onTimeChange.bind(this, "h", "up")}><i className="fa fa-chevron-up" aria-hidden="true"></i></td>
                                                            <td>&nbsp;</td>
                                                            <td onClick={this.onTimeChange.bind(this, "m", "up")}><i className="fa fa-chevron-up" aria-hidden="true"></i></td>
                                                            <td onClick={this.onTimeChange.bind(this, "p", "up")}><i className="fa fa-chevron-up" aria-hidden="true"></i></td>
                                                        </tr>
                                                        <tr>
                                                            <td><input type="text" value={hours} onChange={(value) => this.onInputTime(value, "h")} /></td>
                                                            <td>:</td>
                                                            <td><input type="text" value={minutes} onChange={(value) => this.onInputTime(value, "m")} /></td>
                                                            <td><input type="text" value={(isAM) ? "AM" : "PM"} readOnly={true} /></td>
                                                        </tr>
                                                        <tr>
                                                            <td onClick={this.onTimeChange.bind(this, "h", "down")}><i className="fa fa-chevron-down" aria-hidden="true"></i></td>
                                                            <td>&nbsp;</td>
                                                            <td onClick={this.onTimeChange.bind(this, "m", "down")}><i className="fa fa-chevron-down" aria-hidden="true"></i></td>
                                                            <td onClick={this.onTimeChange.bind(this, "p", "down")}><i className="fa fa-chevron-down" aria-hidden="true"></i></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <label>Service list</label>
                                        {
                                            arrayService && arrayService.map((item, i) => <div className="appointment_service_item" key={i}>
                                                <div className="left">
                                                    {/* <img src={(item.service.image) ? ("http://pos.nailspaofamerica.com/ClientWeb/FileUpload/" + item.service.image) : ("https://www.lapa.co.za/DesktopModules/ATKV.Commerce.BackOffice/Images/no-image.jpg")} /> */}
                                                </div>
                                                <div className="right">
                                                    <span className="service_name">{item.service.name}</span>
                                                    <span className="store_name">By {storeName}</span>
                                                    <div className="qty">
                                                        <i className="fa fa-minus" aria-hidden="true" onClick={() => this.onQtyChange(i, "down")}></i>
                                                        <input className="qty_value" value={item.quantity} disabled={true} onChange={(e) => {

                                                            let arrayService = this.state;
                                                            arrayService[i].quantity++;
                                                            this.setState({
                                                                arrayService
                                                            })
                                                        }} />
                                                        <i className="fa fa-plus" aria-hidden="true" onClick={() => this.onQtyChange(i, "up")}></i>
                                                        <span className="pricce">${item.service.price * item.quantity}</span>
                                                    </div>
                                                    <div className="description">
                                                        <span>{item.service.description}</span>
                                                    </div>
                                                </div>
                                                <div className="service_staff">
                                                    <label onClick={() => {
                                                        this.setState({ isStaffChoise: true, currentService: i })
                                                    }
                                                    }><i className="fa fa-cog" aria-hidden="true"></i> Please select staff </label>
                                                    <span className="staff_name">{(item.staffName) ? item.staffName : ""}</span>
                                                </div>
                                                {
                                                    (i != 0) ? <div className="delete_service">
                                                        <span onClick={() => {
                                                            let { arrayService } = this.state;
                                                            arrayService = arrayService.filter(e => arrayService.indexOf(e) != i)
                                                            this.setState({
                                                                arrayService
                                                            })
                                                        }}> <i className="far fa-trash-alt"></i> Remove</span>
                                                    </div> : ""
                                                }
                                            </div>
                                            )
                                        }

                                        {
                                            (isAddMoreService) ? <div>
                                                {
                                                    storeServices.map((service, i) =>
                                                        <div className="services" key={i}>
                                                            {
                                                                (service.products.length > 0) ? <div>
                                                                    <div className="services_title" onClick={() => this.showServiceList(i)}>
                                                                        <div>
                                                                            <i className="fab fa-gripfire"></i>
                                                                            {service.name}
                                                                            <span>{service.products.length + " services"}</span>
                                                                        </div>
                                                                        <i className={(services_key === i) ? "fas fa-angle-down" : "fas fa-angle-left"}></i>
                                                                    </div>
                                                                    {
                                                                        < div className="services_table" style={{ maxHeight: (services_key === i) ? "1000px" : "0px", overflow: "hidden", transition: "all 0.5s linear", borderTop: (services_key === i) ? "1px solid #e9e9e9" : "none" }}>
                                                                            <div className="clearfix">
                                                                                <div className="column-right">
                                                                                    {service.products.map((serviceItem, j) =>
                                                                                        <div className="col_6 col_sm_12" key={j}>
                                                                                            <div className="row_col">
                                                                                                <span className="service-name">{serviceItem.name}
                                                                                                    <i style={{ float: "right" }}>{"$" + serviceItem.price}</i>
                                                                                                </span>
                                                                                                {/* <span className="book-now" onClick={() => { this.handleBook(serviceItem); this.refs.appointment.hanleReset(); }}><i className="fa fa-calendar-plus-o" aria-hidden="true"></i> Book now</span> */}

                                                                                            </div>
                                                                                            <i className={(product_key === j) ? "fas fa-angle-down" : "fas fa-angle-left"} onClick={() => this.showProductList(j)} />
                                                                                            <div className="product-list" style={{ maxHeight: (product_key === j) ? "300px" : "0px", overflow: "hidden", transition: "all 1s linear", borderTop: (product_key === j) ? "1px solid #e9e9e9" : "none" }}>
                                                                                                <div className="product-decription">
                                                                                                    <span>{serviceItem.description}</span>
                                                                                                </div>
                                                                                                <div className="product-appointment-bt">
                                                                                                    <span onClick={() => {
                                                                                                        let { arrayService } = this.state;
                                                                                                        arrayService.push({
                                                                                                            staffId: (this.props.staffs.length > 0) ? this.props.staffs[0].id : 0,
                                                                                                            staffName: (this.props.staffs.length > 0) ? this.props.staffs[0].name : "",
                                                                                                            service: serviceItem,
                                                                                                            quantity: 1
                                                                                                        })
                                                                                                        this.setState({
                                                                                                            arrayService,
                                                                                                            isAddMoreService: false
                                                                                                        })
                                                                                                    }
                                                                                                    } style={{ cursor: "pointer" }}>Appointment Now</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div> : ""
                                                            }
                                                        </div>

                                                    )
                                                }
                                            </div> : <div className="bt_add_more_service"><span onClick={() => this.setState({ isAddMoreService: true })}><i className="fas fa-plus"></i>Add more service</span></div>
                                        }
                                        {
                                            (isAddMoreService) ? <div className="cancel-add"><span onClick={() => this.setState({ isAddMoreService: false })}>Cancel</span></div> : ""
                                        }


                                        <div className="note">
                                            <label onClick={
                                                () => {
                                                    (isNote) ? $("#appointmentNote").fadeIn() : $("#appointmentNote").slideUp();
                                                    this.setState({ isNote: !isNote })
                                                }
                                            }>Note</label>
                                            <textarea id="appointmentNote" style={{ display: "none" }} value={appointmentNote} onChange={(e) => this.onNoteChange(e)} />
                                        </div>
                                        <div className="footer">
                                            <span className="cancel" onClick={this.props.handleClose}>Cancel</span>
                                            <span className="submit" onClick={() => {
                                                $("#appointment_service").fadeOut(50);
                                                $("#customer_info").fadeIn(500);
                                            }}
                                            >Next</span>
                                        </div>
                                    </div>
                                    <div id="customer_info" className="customer_info" style={{ display: "none" }}>
                                        <div className="customer_detail">
                                            <TextIput
                                                name="customerName"
                                                label="Your Name"
                                                showLabel={true}
                                                showPlaceholder={false}
                                                value={this.state.customerName}
                                                validations={validationData.customerName}
                                                onChange={(value) => this.setState({
                                                    customerName: value
                                                })}
                                            />
                                            <TextIput
                                                name="mailAddress"
                                                label="Email Address"
                                                showLabel={true}
                                                showPlaceholder={true}
                                                placeholder="yourmail@example.com"
                                                value={this.state.mailAddress}
                                                validations={validationData.mailAddress}
                                                onChange={(value) => this.setState({
                                                    mailAddress: value
                                                })}
                                            />
                                            <TextIput
                                                name="phone"
                                                label="Phone"
                                                showLabel={true}
                                                showPlaceholder={false}
                                                value={this.state.phone}
                                                validations={validationData.phone}
                                                onChange={(value) => this.setState({
                                                    phone: value
                                                })}
                                            />
                                            <TextIput
                                                name="address"
                                                label="Address"
                                                showLabel={true}
                                                showPlaceholder={false}
                                                value={this.state.address}
                                                validations={validationData.address}
                                                onChange={(value) => this.setState({
                                                    address: value
                                                })}
                                            />
                                        </div>
                                        <div className="customer_footer">
                                            <span className="go_back" onClick={() => {
                                                $("#customer_info").fadeOut(500);
                                                $("#appointment_service").fadeIn(500);
                                            }}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</span>
                                            <span className="submit" onClick={() => this.handleBook()}>
                                                {
                                                    (isProsessing) ? <i className="fa fa-spinner fa-pulse" style={{ marginRight: "10px" }}> </i> : ""
                                                }
                                                {(isProsessing) ? "Waiting..." : "Book now"}</span>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="staff">
                                    {
                                        <div className="title">
                                            <span> Select staff for {arrayService[currentService].service.name} at {(moment(this.state.date).format("dddd, MM DD YYYY").toString() + " " + this.state.hours + ":" + this.state.minutes) + ((this.state.isAM) ? " AM" : " PM")}</span>
                                        </div>
                                    }
                                    <div className="staff_detail">
                                        {
                                            staffs.map((staffItem, i) =>
                                                <div className={((staffItem.id === arrayService[this.state.currentService].staffId) ? "staff_item acctive " : "staff_item ") + ((staffItem.id != staffs[0].id) ? this.checkStaffSchedule(this.state.date, staffItem.workHours) : "")} key={i} >
                                                    <div className="header" onClick={() => {
                                                        if (this.getHoursToDay(staffItem.workHours, staffItem.appointments) == "Available")
                                                            this.onSelectStaff(staffItem);
                                                        else
                                                            alert("This staff does not work for the time period you choose.")
                                                    }}>
                                                        <span className="staff_ID">#{staffItem.id} : {staffItem.name}</span>
                                                    </div>
                                                    <div className="contain">
                                                        <div className="avatar" onClick={() => {
                                                            if (this.getHoursToDay(staffItem.workHours, staffItem.appointments) == "Available")
                                                                this.onSelectStaff(staffItem);
                                                            else
                                                                alert("This staff does not work for the time period you choose.")
                                                        }}>
                                                            <image src={staffItem.avatar} />
                                                        </div>
                                                        <div className="info" onClick={() => {
                                                            if (this.getHoursToDay(staffItem.workHours, staffItem.appointments) == "Available")
                                                                this.onSelectStaff(staffItem);
                                                            else
                                                                alert("This staff does not work for the time period you choose.")
                                                        }}>
                                                            <span className="phone">Phone: {staffItem.phone}</span>
                                                            <span className="email">Email: {staffItem.mail}</span>
                                                        </div>
                                                        <div className={"work_time" + ((currentWorkTimeTab == i) ? " active" : "")} onClick={() => this.setState({ currentWorkTimeTab: i })}>
                                                            {
                                                                (staffItem.workHours && staffItem.workHours.length > 0 && staffItem.id != staffs[0].id) ? staffItem.workHours.map((workTime, j) =>
                                                                    <div className="work_time_item" key={j}>
                                                                        {
                                                                            (this.getHoursToDay(staffItem.workHours, staffItem.appointments) == "Available") ?
                                                                                <p style={{ background: "#fff", textAlign: "right" }}><span style={{ color: "green" }}>Available</span></p> :
                                                                                <p style={{ background: "#fff", textAlign: "right" }}><span style={{ color: "red" }}>{this.getHoursToDay(staffItem.workHours, staffItem.appointments)}</span></p>
                                                                        }
                                                                        <div>
                                                                            <p >Appointments and work schedule</p>
                                                                            {
                                                                                (staffItem.appointments.length > 0) ? <span className="appointment-title">Appointments in this day:</span> : ""
                                                                            }
                                                                            {
                                                                                <div className="appointment">
                                                                                    {
                                                                                        staffItem.appointments.map((item, k) =>
                                                                                            (moment(item.startTime).format("MM DD YYYY") === moment(this.state.date).format("MM DD YYYY")) ? <span key={k}>{(k + 1) + ". " + moment(moment.utc(item.startTime).toDate()).format("HH:mm") + " to " + moment(moment.utc(item.endTime).toDate()).format("HH:mm")} </span> : ""
                                                                                        )
                                                                                    }
                                                                                </div>
                                                                            }
                                                                            {
                                                                                (staffItem.appointments) ? <span className="work-schedule-title">Work schedule:</span> : ""
                                                                            }
                                                                            {
                                                                                (workTime.mondayStart != "" && workTime.mondayEnd != "") && <span className={(moment(this.state.date).day() == 1) ? "active" : ""}>{"Monday: " + workTime.mondayStart + " to " + workTime.mondayEnd}</span>
                                                                            }
                                                                            {
                                                                                (workTime.tuesdayStart != "" && workTime.tuesdayEnd != "") && <span className={(moment(this.state.date).day() == 2) ? "active" : ""}>{"Tuesday: " + workTime.tuesdayStart + " to " + workTime.tuesdayEnd}</span>
                                                                            }
                                                                            {
                                                                                (workTime.wednesdayStart != "" && workTime.wednesdayEnd != "") && <span className={(moment(this.state.date).day() == 3) ? "active" : ""}>{"Wednesday: " + workTime.wednesdayStart + " to " + workTime.wednesdayEnd}</span>
                                                                            }
                                                                            {
                                                                                (workTime.thursdayStart != "" && workTime.thursdayEnd != "") && <span className={(moment(this.state.date).day() == 4) ? "active" : ""}>{"Thursday: " + workTime.thursdayStart + " to " + workTime.thursdayEnd}</span>
                                                                            }
                                                                            {
                                                                                (workTime.fridayStart != "" && workTime.fridayEnd != "") && <span className={(moment(this.state.date).day() == 5) ? "active" : ""}>{"Friday: " + workTime.fridayStart + " to " + workTime.fridayEnd}</span>
                                                                            }
                                                                            {
                                                                                (workTime.saturdayStart != "" && workTime.saturdayEnd != "") && <span className={(moment(this.state.date).day() == 6) ? "active" : ""}>{"Saturday: " + workTime.saturdayStart + " to " + workTime.saturdayEnd}</span>
                                                                            }
                                                                            {
                                                                                (workTime.sundayStart != "" && workTime.sundayEnd != "") && < span className={(moment(this.state.date).day() == 0) ? "active" : ""}>{"Sunday: " + workTime.sundayStart + " to " + workTime.sundayEnd}</span>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                ) : ""
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className="staff_footer">
                                        <span className="go_back" onClick={() => this.setState({ isStaffChoise: false })}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</span>
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/appointment/index.js